import { Injectable } from '@angular/core';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { ApplicationStateStorageService } from './application-state-storage.service';
import { ApplicationStateService } from './application-state.service';
import {noop} from '../../core/utils/utils';
import {SectionComponentKey} from '../../core/enums/components-keys';

@Injectable({
  providedIn: 'root'
})
export class SectionsStateService {
  
  constructor(private applicationState: ApplicationStateService,
              private storage: ApplicationStateStorageService) {
    this.applicationState.state.sectionsState = isNotNullOrUndefined(this.getSectionStates()) ? this.getSectionStates() : [];
  }
  
  createOrUpdateSectionState(sectionKey: string, sectionMode: SectionModeState): void {
    let sectionState = this.getSectionStates().find(section => section.key === sectionKey);
    if (isNotNullOrUndefined(sectionState)) {
      sectionState.mode = sectionMode;
    } else {
      this.getSectionStates().push(new SectionState(sectionKey, sectionMode));
    }
    this.storage.updateApplicationState();
  }

  resetCreatedAtLeastOnce(sectionKey: string): void {
    let sectionState = this.getSectionStates().find(section => section.key === sectionKey);
    if (isNotNullOrUndefined(sectionState)) {
      delete sectionState.createdAtLeastOnce;
    }
  }
  
  sectionState(sectionKey: string): SectionState {
    return this.getSectionStates().find(section => section.key === sectionKey);
  }

  prepareFirstStepAfterAztecData(): void {
    let sectionState = this.sectionState(SectionComponentKey.VEHICLE_MODEL);
    isNotNullOrUndefined(sectionState) ? sectionState.createdAtLeastOnce = null : noop();
  }

  setModeInAllSections(mode: SectionModeState): void {
    this.getSectionStates().forEach(sectionState => sectionState.mode = mode);
  }
  
  private getSectionStates(): SectionState[] {
    return this.applicationState.state.sectionsState;
  }
}

export enum SectionModeState {
  PREVIEW = 'PREVIEW',
  EDIT = 'EDIT'
}

export class SectionState {
  key: string;
  mode: SectionModeState;
  pristineClicked: boolean;
  createdAtLeastOnce: boolean;

  constructor(sectionKey: string, mode: SectionModeState, pristineClicked?: boolean, createdAtLeastOnce?: boolean) {
    this.key = sectionKey;
    this.mode = mode;
    this.pristineClicked = pristineClicked;
    this.createdAtLeastOnce = createdAtLeastOnce;
  }
}

